<template>
  <nuxt-link
    :to="localePath({ name: 'blog-slug', params: { slug: item.key } })"
    class="blogBigTile"
  >
    <div class="blogBigTile__image">
      <new-image-box
        :alt="item.title"
        :src="item.image"
        :width="700"
        :height="480"
        fit
        image-params="w_700,h_480,crop"
      />
    </div>
    <div class="blogBigTile__content">
      <div class="blogBigTile__category" v-if="item.category">
        {{ item.category }}
      </div>
      <h3 class="blogBigTile__title">
        {{ item.title }}
      </h3>
      <div class="blogBigTile__desc">
        {{ item.description }}
      </div>
      <div class="blogBigTile__link"><span class="blogBigTile__linkText">CZYTAJ DALEJ</span></div>
    </div>
  </nuxt-link>
</template>

<script>
import NewImageBox from '@/components/NewImageBox';

export default {
  name: 'BlogBigTile',
  components: {
    NewImageBox,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imageParams() {
      if (this.$device.isMobile) return 'w_380,h_400';
      return 'w_700,h_480,crop';
    },
  },
};
</script>

<style lang="scss">
.blogBigTile {
  $root: &;
  position: relative;
  display: block;
  height: 100%;

  @include rwd('tablet') {
    min-height: 40rem;
  }

  &__image {
    position: relative;
    overflow: hidden;
    height: 100%;

    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      background: rgba($cBlack, 0.3);
      background: linear-gradient(0deg, rgba(23, 25, 51, 0.7) 0%, rgba(255, 255, 255, 0) 100%);
    }

    img {
      transition: transform $tr, opacity $tr;
    }
  }

  &__content {
    position: absolute;
    left: 4rem;
    bottom: 4rem;
    color: $cWhite;

    @include rwd('tablet') {
      left: 2rem;
      bottom: 2rem;
    }
  }

  &__category {
    margin-bottom: 1.8rem;
    font-size: 1.1rem;
    line-height: 1.4rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    text-transform: uppercase;
  }

  &__title {
    margin-bottom: 2rem;
    font-weight: 600;
    font-size: 2.2rem;
    line-height: 2.8rem;
    padding-right: 2rem;
    transition: color $tr;

    @include rwd('large-tablet') {
      font-size: 2rem;
      line-height: 2.6rem;
    }

    @include rwd('tablet') {
      font-size: 1.8rem;
      line-height: 2.4rem;
    }
  }

  &__desc {
    margin-bottom: 2.2rem;
    font-size: 1.4rem;
    line-height: 2rem;
    padding-right: 5rem;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    @include rwd('tablet') {
      padding-right: 2rem;
    }
  }

  &__link {
  }

  &__linkText {
    display: inline-block;
    padding-bottom: 6px;
    position: relative;
    font-size: 1.2rem;
    line-height: 1.5rem;
    font-weight: 700;

    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: $cWhite;
    }
  }

  &:hover {
    #{$root}__image {
      img {
        transform: scale(1.05);
      }
    }
  }

  &--horizontal {
    display: flex;
    align-items: center;

    #{$root}__image {
      flex: 0 0 50%;
      max-width: 50%;
      padding-right: 3.7rem;
      margin-bottom: 0;
    }

    #{$root}__content {
      height: auto;
    }
  }
}
</style>
